/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main-flex">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>权限菜单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="allKnowledge-header-box">
      <el-button type="primary" size="small" @click="btnClick(0)">刷新</el-button>
      <el-button type="primary" size="small" @click="btnClick(1)">新增</el-button>
    </div>
    <div class="allKnowledge-table-box" ref="tableBox">
      <el-tree node-key="menuId" :data="treeData.list" :props="{ label: 'menuName', children: 'children' }"
        default-expand-all :expand-on-click-node="false" highlight-current @node-click="nodeClick">
        <template #default="{ node, data }">
          <span class="d-flex flex-align-center flex-justify-between flex-1">
            <span>{{ node.label }}</span>
            <i class="el-icon-close" @click.stop="remove(node, data)"></i>
          </span>
        </template>
      </el-tree>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible" :close-on-click-modal="false"
      custom-class="form-dialog" width="70%" @close='closeDialog("edit")'>
      <my-form :form-config="formConfig.formItems" ref="editForm" :formRules="formConfig.formRules" @submit="submitForm"
        :dataForm="formConfig.dataForm">
      </my-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import myForm from '@/components/myForm.vue';
import { menuList, menuAdd, menuEdit, menuRemove } from '@/api/menuMG.js'

export default {
  components: {
    myForm
  },
  data () {
    return {
      treeData: {
        list: []
      },
      dialogTitle: '',
      dialogTableVisible: false,
      formConfig: {
        formItems: [
          {
            type: 'cascader', prop: 'pid', label: '所属菜单', span: 12,
            options: []
            , property: {
              clearable: true,
              disabled: false,
              filterable: true,
              props: {
                label: 'menuName', value: 'menuId',
                checkStrictly: true
              }
            },
            placeholder:'请选择所属菜单'
          },
          { type: 'input', prop: 'menuName', label: '菜单名称', span: 12, placeholder:'请输入菜单名称'},
          { type: 'input', prop: 'routingAddress', label: '路由地址', span: 12, placeholder:'请输入路由地址：/system/user' },
          { type: 'input', prop: 'permissionFlag', label: '权限标识', span: 12,  placeholder:'请输入权限标识:system:user:add' },
          {
            type: 'select', prop: 'type', label: '类型', span: 12, options: [
              { label: '菜单', id: 'MENU' },
              { label: '按钮', id: 'BUTTON' },
              { label: '页面', id: 'PAGE' },
              { label: '标签', id: 'TAB' }
            ]
          },
          { type: 'input', prop: 'desc', label: '描述', span: 12, placeholder:'请输入描述'},
          { type: 'number', prop: 'sort', label: '排序', span: 12, min: 1 },
        ],
        formRules: {
          menuName: { required: true, message: '请输入名称', trigger: 'blur' },
          routingAddress: { required: true, message: '请输入地址', trigger: 'blur' },
          type: { required: true, message: '请选择类型', trigger: 'change' },
          sort: { required: true, message: '请输入排序', trigger: 'blur' }
        },
        dataForm: {
          sort: 1, type: 'MENU', pid: 0, showStatus: 1
        }
      }

    }
  },
  /**
   * 创建完毕
   */

  created () {
    this.getData();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    async getData () {
      const data = (await menuList()).data;
      this.treeData.list = data;
      this.formConfig.formItems[0].options = data;
    },
    async btnClick (index) {
      switch (index) {
        case 0:
    this.getData();
          break;
        case 1:
          this.formConfig.formItems[0].property.disabled = false;
          this.dialogTitle = '菜单新增';
          this.dialogTableVisible = true;
          break;
      }
    },
    async nodeClick (data) {
      this.formConfig.formItems[0].property.disabled = true;
      this.dialogTitle = '菜单编辑';
      this.dialogTableVisible = true;
      const form = JSON.parse(JSON.stringify(data));
      if (!form.helpVideo) form.helpVideo = [];
      this.formConfig.dataForm = form;
    },
    async remove (node, data) {
      await this.$alert(data.children.length <= 0 ? '确认删除吗？' : '当前节点包含子菜单，确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: async Action => {
          if (Action === 'confirm') {
            await menuRemove([data.menuId]);
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            const index = children.findIndex((d) => d.menuId === data.menuId);
            children.splice(index, 1);
            this.treeData.list = [...this.treeData.list];
          }
        }
      });
    },
    async submitForm () {
      const data = this.formConfig.dataForm;

      this.$refs.editForm.$refs.form.validate(async (valid) => {
        if (valid) {
          if (data.pid.length > 0 && !data.menuId) data.pid = data.pid[data.pid.length - 1].toString();
          const res = await (data.menuId ? menuEdit(data) : menuAdd(data));
          this.closeDialog();
          await this.getData();
          this.$message.success(res.msg);
        } else {
          return false;
        }
      });
    },
    closeDialog () {
      this.formConfig.dataForm = { sort: 1, type: 'MENU', pid: 0, showStatus: 1, helpVideo: [] };
      this.$refs.editForm.$refs.form.resetFields();

      this.dialogTableVisible = false
    },
  }
}
</script>

<style scoped lang="scss">
.allKnowledge-header-box {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .05);
  margin-bottom: 10px;
  padding: 18px 20px;
  display: flex;
  justify-content: flex-end;
}

.allKnowledge-table-box {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .05);
  flex: 1;
  margin-bottom: 10px;
  padding: 20px;
  overflow-y: auto;

  .allKnowledge-operation-box {
    position: relative;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:after {
      position: absolute;
      content: ' ';
      left: 0;
      bottom: 0;
      height: 1px;
      width: 100%;
      background-color: #dfe1e6;
    }

    .graph-refresh-box {
      display: flex;
      align-items: center;
      padding-left: 15px;
      border-left: 1px solid #dfe1e6;

      .graph-refresh-icon {
        cursor: pointer;

        &:hover {
          animation: rotation 1s linear infinite;
        }

        @keyframes rotation {
          from {
            transform: rotate(0deg)
          }

          to {
            transform: rotate(360deg)
          }
        }
      }
    }

    .graph-list-box {
      padding: 2px 10px;
      border: 1px solid #409eff;
      border-radius: 2px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }
}</style>

 
 


// WEBPACK FOOTER //
// src/views/system/Module.vue